/*
 * @Author: Kuiper
 * @Date: 2021-06-24 20:22:50
 */
import { StateType } from '/@/store/types'
import { Module } from 'vuex'
interface Token {
  [propertys: string]: any
}

const state = {
  token: {} as Token,
  lastTime: 0,
  userInfo: {
    code: -1,
    ak: undefined,
    uid: undefined,
    nickname: undefined,
    avatar: undefined,
    mobile: undefined,
    role: undefined,
  },
  currentTeamRoleId: 0, // 当前所选择的团队用户所具有的权限
  currentProjectRoleId: 0, // 当前所选择的项目用户所具有的权限
}
type UserStateType = typeof state

const user: Module<UserStateType, StateType> = {
  namespaced: true,
  ...state,
}

export { UserStateType, state }
export default user
